<app-loading *ngIf="contentReady"></app-loading>

<section
  class="bbm-page orders-profit-mobile-page"
  [class.rtl]="isAr"
  [dir]="isAr ? 'rtl' : 'ltr'"
  *ngIf="!contentReady"
>
  <div class="bbm-shell">

    <!-- HERO -->
    <section class="bbm-hero">

      <div class="bbm-hero-top">

        <div class="bbm-hero-copy">
          <span class="bbm-eyebrow">
            {{ 'Financial reports' | transloco }}
          </span>

          <h2>
            {{ 'orderprofit' | transloco }}
          </h2>

          <p>
            {{ 'Order profit description' | transloco }}
          </p>
        </div>

        <div class="bbm-hero-counter">
          <strong>
            {{ totalRecords || 0 }}
          </strong>

          <span>
            {{ 'Orders' | transloco }}
          </span>
        </div>

      </div>

    </section>

    <!-- ERROR MESSAGE -->
    <div
      class="bbm-alert bbm-alert-danger"
      *ngIf="errorMessage"
      role="alert"
    >
      <i class="fa-solid fa-circle-exclamation"></i>

      <span>
        {{ errorMessage }}
      </span>
    </div>

    <!-- FILTERS -->
    <section class="bbm-form-ticket noPrint">

      <div class="bbm-form-head">
        <div>
          <span class="bbm-eyebrow">
            {{ 'Financial reports' | transloco }}
          </span>

          <h3>
            {{ 'Filters' | transloco }}
          </h3>
        </div>
      </div>

      <div class="bbm-form-grid">

        <!-- WAREHOUSE -->
        <div class="bbm-field bbm-field-wide">
          <label for="order-profit-warehouse">
            {{ 'warehouse' | transloco }}
          </label>

          <select
            id="order-profit-warehouse"
            class="bbm-control"
            [(ngModel)]="warehouseId"
            (change)="applyFilters()"
          >
            <option
              *ngFor="let warehouse of warehouses"
              [ngValue]="warehouse.id"
            >
              {{
                isAr
                  ? (warehouse.name || warehouse.name_en)
                  : (warehouse.name_en || warehouse.name)
              }}
            </option>
          </select>
        </div>

        <!-- YEAR -->
        <div class="bbm-field">
          <label for="order-profit-year">
            {{ 'Year' | transloco }}
          </label>

          <select
            id="order-profit-year"
            class="bbm-control"
            [(ngModel)]="selectedYear"
            (change)="applyFilters()"
          >
            <option
              *ngFor="let year of years"
              [ngValue]="year"
            >
              {{ year }}
            </option>
          </select>
        </div>

        <!-- MONTH -->
        <div class="bbm-field">
          <label for="order-profit-month">
            {{ 'Month' | transloco }}
          </label>

          <select
            id="order-profit-month"
            class="bbm-control"
            [(ngModel)]="selectedMonth"
            (change)="applyFilters()"
          >
            <option
              *ngFor="let month of months"
              [ngValue]="month.value"
            >
              {{ month.key | transloco }}
            </option>
          </select>
        </div>

      </div>

    </section>

    <!-- SUMMARY -->
    <section class="bbm-details-grid bbm-summary-grid bbm-section">

      <!-- TOTAL SALES -->
      <div class="bbm-detail-chip bbm-detail-success">
        <i class="fa-solid fa-arrow-trend-up"></i>

        <span>
          {{ 'total sales' | transloco }}
        </span>

        <strong class="bbm-money-value">
          {{ totalRevenue | number:'1.2-2' }}
          {{ 'EGP' | transloco }}
        </strong>
      </div>

      <!-- TOTAL COST -->
      <div class="bbm-detail-chip bbm-detail-danger">
        <i class="fa-solid fa-boxes-stacked"></i>

        <span>
          {{ 'Total cost' | transloco }}
        </span>

        <strong class="bbm-money-value">
          {{ totalCost | number:'1.2-2' }}
          {{ 'EGP' | transloco }}
        </strong>
      </div>

      <!-- NET PROFIT -->
      <div
        class="bbm-detail-chip bbm-detail-wide"
        [class.bbm-detail-success]="netProfit >= 0"
        [class.bbm-detail-danger]="netProfit < 0"
      >
        <i
          class="fa-solid"
          [class.fa-chart-line]="netProfit >= 0"
          [class.fa-arrow-trend-down]="netProfit < 0"
        ></i>

        <span>
          {{ 'Net profit' | transloco }}
        </span>

        <strong class="bbm-money-value">
          {{ netProfit | number:'1.2-2' }}
          {{ 'EGP' | transloco }}
        </strong>
      </div>

      <!-- ORDER COUNT -->
      <div class="bbm-detail-chip bbm-detail-primary bbm-detail-wide">
        <i class="fa-solid fa-cart-shopping"></i>

        <span>
          {{ 'Orders' | transloco }}
        </span>

        <strong>
          {{ totalRecords | number }}
        </strong>
      </div>

    </section>

    <!-- PROFIT DETAILS -->
    <section class="bbm-records-section">

      <div class="bbm-list-head">
        <div>
          <span>
            {{ 'Financial reports' | transloco }}
          </span>

          <h3>
            {{ 'Profit details' | transloco }}
          </h3>

          <p>
            {{ totalRecords }}
            {{ 'Orders' | transloco }}
          </p>
        </div>

        <span class="bbm-list-counter">
          {{ profits.length || 0 }}
        </span>
      </div>

      <!-- PROFIT LIST -->
      <div
        class="bbm-ticket-list"
        *ngIf="profits.length; else emptyState"
      >

        <article
          class="bbm-ticket"
          [class.bbm-ticket-success]="rowProfit(row) >= 0"
          [class.bbm-ticket-danger]="rowProfit(row) < 0"
          *ngFor="
            let row of profits;
            trackBy: trackByProfitId
          "
        >

          <!-- CARD TOP -->
          <div class="bbm-ticket-top">

            <div class="bbm-main-info">

              <div class="bbm-avatar">
                <i class="fa-solid fa-receipt"></i>
              </div>

              <div class="bbm-copy">
                <span>
                  {{ 'Order' | transloco }}
                </span>

                <h3
                  class="bbm-code-value"
                  dir="ltr"
                >
                  #{{ getOrderId(row) }}
                </h3>

                <p>
                  <i class="fa-regular fa-user"></i>

                  <span>
                    {{ getUserName(row) || '-' }}
                  </span>
                </p>
              </div>

            </div>

            <span
              class="bbm-status-pill"
              [class.bbm-status-success]="rowProfit(row) >= 0"
              [class.bbm-status-danger]="rowProfit(row) < 0"
            >
              <i
                class="fa-solid"
                [class.fa-arrow-trend-up]="rowProfit(row) >= 0"
                [class.fa-arrow-trend-down]="rowProfit(row) < 0"
              ></i>

              {{ rowProfit(row) | number:'1.2-2' }}
              {{ 'EGP' | transloco }}
            </span>

          </div>

          <!-- ORDER INFORMATION -->
          <div class="bbm-details-grid">

            <!-- USER -->
            <div class="bbm-detail-chip">
              <i class="fa-regular fa-user"></i>

              <span>
                {{ 'employee' | transloco }}
              </span>

              <strong>
                {{ getUserName(row) || '-' }}
              </strong>
            </div>

            <!-- DATE -->
            <div class="bbm-detail-chip">
              <i class="fa-regular fa-calendar"></i>

              <span>
                {{ 'date' | transloco }}
              </span>

              <strong>
                {{
                  row.created_at
                    ? (row.created_at | date:'mediumDate')
                    : '-'
                }}
              </strong>
            </div>

            <!-- GROSS SALES -->
            <div class="bbm-detail-chip bbm-detail-success">
              <i class="fa-solid fa-money-bill-trend-up"></i>

              <span>
                {{ 'Gross sales' | transloco }}
              </span>

              <strong class="bbm-money-value">
                {{ rowRevenue(row) | number:'1.2-2' }}
                {{ 'EGP' | transloco }}
              </strong>
            </div>

            <!-- PRODUCTS COST -->
            <div class="bbm-detail-chip bbm-detail-danger">
              <i class="fa-solid fa-boxes-stacked"></i>

              <span>
                {{ 'Products cost' | transloco }}
              </span>

              <strong class="bbm-money-value">
                {{ rowCost(row) | number:'1.2-2' }}
                {{ 'EGP' | transloco }}
              </strong>
            </div>

            <!-- DEDUCTIONS -->
            <div class="bbm-detail-chip bbm-detail-warning">
              <i class="fa-solid fa-percent"></i>

              <span>
                {{ 'Deductions' | transloco }}
              </span>

              <strong class="bbm-money-value">
                {{ rowDeductions(row) | number:'1.2-2' }}
                {{ 'EGP' | transloco }}
              </strong>
            </div>

            <!-- ITEMS AND QUANTITY -->
            <div class="bbm-detail-chip">
              <i class="fa-solid fa-box-open"></i>

              <span>
                {{ 'Items / Qty' | transloco }}
              </span>

              <strong>
                {{ row.items_count || 0 }}
                /
                {{ row.total_quantity || 0 }}
              </strong>
            </div>

            <!-- NET PROFIT -->
            <div
              class="bbm-detail-chip bbm-detail-wide"
              [class.bbm-detail-success]="rowProfit(row) >= 0"
              [class.bbm-detail-danger]="rowProfit(row) < 0"
            >
              <i
                class="fa-solid"
                [class.fa-chart-line]="rowProfit(row) >= 0"
                [class.fa-arrow-trend-down]="rowProfit(row) < 0"
              ></i>

              <span>
                {{ 'Net profit' | transloco }}
              </span>

              <strong class="bbm-money-value">
                {{ rowProfit(row) | number:'1.2-2' }}
                {{ 'EGP' | transloco }}
              </strong>
            </div>

          </div>

          <!-- PARTIALLY COMPLETED -->
          <div
            class="bbm-badges-row order-profit-partial-state"
            *ngIf="row.is_partially_completed"
          >
            <span class="bbm-status-pill bbm-status-warning">
              <i class="fa-solid fa-circle-info"></i>

              {{ 'Partially completed' | transloco }}
            </span>
          </div>

        </article>

      </div>

      <!-- EMPTY STATE -->
      <ng-template #emptyState>
        <div
          class="bbm-empty-state"
          *ngIf="noData"
        >
          <i class="fa-solid fa-chart-line"></i>

          <h4>
            {{ 'No order profits' | transloco }}
          </h4>
        </div>
      </ng-template>

      <!-- LOADING MORE -->
      <div
        class="bbm-loading-panel"
        *ngIf="loadingMore"
      >
        <app-loading></app-loading>
      </div>

      <!-- END STATE -->
      <div
        class="bbm-end-state"
        *ngIf="!hasMorePages && profits.length"
      >
        {{ 'All results loaded' | transloco }}
      </div>

    </section>

  </div>
</section>